import { RESET_STATE } from 'services/auth/constants';
import { ResetStateAction } from 'services/auth/types';
import {
    SPRAY_SUBMISSION_SET
} from './constants';
import { SpraySubmissionState, SpraySubmissionsTypes } from './types';

const initialState = null;

export default function (
    state: SpraySubmissionState = initialState,
    action: SpraySubmissionsTypes | ResetStateAction
): SpraySubmissionState {
    switch (action.type) {
        case SPRAY_SUBMISSION_SET:
            return action.payload;
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
